// src/components/admin/AdminLayout.jsx
import React, { useState } from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import './AdminLayout.css';
import logo from '../assets/logo.png';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminData');
    navigate('/admin/login');
  };

  const menuItems = [
    { path: '/admin/dashboard', icon: '📊', label: 'Dashboard' },
    { path: '/admin/leads', icon: '🧲', label: 'Leads' },
    { path: '/admin/store-requests', icon: '📋', label: 'Customers / Stores' },
    { path: '/admin/stores', icon: '🏪', label: 'Active Stores' },
    { path: '/admin/payments', icon: '🏪', label: 'Payments' },
    { path: '/admin/content-submissions', icon: '🏪', label: 'Content Submissions' },
    { path: '/admin/customers', icon: '👥', label: 'Customers' },
    { path: '/admin/support-tickets', icon: '👥', label: 'Support Tickets' },
    { path: '/admin/settings', icon: '⚙️', label: 'Settings' },
  ];

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Real: reads whatever admin-login.php actually stored, instead of a
  // hardcoded "Admin" / "Super Admin". Falls back gracefully if the shape
  // doesn't match what I'm guessing (username/role) or if it's missing.
  let adminName = 'Admin';
  let adminRole = 'Admin';
  try {
    const stored = JSON.parse(localStorage.getItem('adminData') || '{}');
    adminName = stored.username || stored.name || adminName;
    adminRole = stored.role || adminRole;
  } catch (e) {
    // malformed/missing adminData — keep defaults
  }
  const adminInitial = adminName.charAt(0).toUpperCase();

  // Dynamic page title: matches the current route against menuItems,
  // including nested detail routes like /admin/store-requests/5
  const currentPage = menuItems.find(
    item => location.pathname === item.path || location.pathname.startsWith(item.path + '/')
  );
  const pageTitle = currentPage?.label || 'Dashboard';

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <div className="logo">
            
            {sidebarOpen && (
              <div className="logo-text-block">
                <img src={logo} alt="Logo" className="logo-icon" />
                <span className="logo-text"></span>
                <span className="logo-subtext">Admin Panel</span>
              </div>
            )}
          </div>
          <button className="toggle-btn" onClick={toggleSidebar}>
            {sidebarOpen ? '‹' : '›'}
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`sidebar-item ${isActive ? 'active' : ''}`}
                title={!sidebarOpen ? item.label : undefined}
              >
                <span className="sidebar-icon">{item.icon}</span>
                {sidebarOpen && <span className="sidebar-label">{item.label}</span>}
              </Link>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <button onClick={handleLogout} className="logout-item" title={!sidebarOpen ? 'Logout' : undefined}>
            <span className="sidebar-icon">🚪</span>
            {sidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className={`admin-main ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="admin-header">
          <h1>{pageTitle}</h1>
          <div className="header-actions">
            <div className="admin-profile">
              <div className="admin-avatar">{adminInitial}</div>
              <div className="admin-info">
                <span className="admin-name">{adminName}</span>
                <span className="admin-role">{adminRole}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;